module.exports = __webpack_public_path__ + "static/media/SO.1f84c0c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/SO.svg
// module id = 363
// module chunks = 0